/*
 * Module for example locale.
 */

define([
  "marionette",
  "messaging/messenger",
  "modules/topicsSplit/topic/topicExampleModal/exampleLocale/exampleLocaleView",
], function (Marionette, Messenger, ExampleLocaleView) {
  return Marionette.Controller.extend({
    initialize: function (options) {
      this.region = options.region;
      this.selectedLocale = options.selectedLocale;
      this.showOnlyEnglishLocales = options.showOnlyEnglishLocales;
      this.name = "locale";
      this._setUpVents();
      this._setUpReqres();
    },
    show: function (example) {
      const languages = Messenger.reqres.request("kb:languages");
      this.exampleModel = example;
      this.exampleModel.languages = languages;
      this.exampleModel.selectedLocale = this.selectedLocale;
      this.exampleModel.showOnlyEnglishLocales = this.showOnlyEnglishLocales;

      this.view = new ExampleLocaleView.exampleLocaleView({ model: this.exampleModel });
      this.view.on(
        "change:locale",
        function () {
          // If a locale other than English is selected, then send a message to the parent module to hide the optional
          // and substitution buttons and the suppress from autocomplete check box. Otherwise, display it again
          const localeId = this.view.getLocaleId();
          this.exampleModel.set("localeId", localeId);
          const isEnglish = Messenger.reqres.request("kb:language:is:english", localeId);
          if (!isEnglish) {
            Messenger.vent.trigger("hide:example:buttons", true);
            Messenger.vent.trigger("hide:translate:button", false);
          } else {
            Messenger.vent.trigger("hide:example:buttons", false);
            Messenger.vent.trigger("hide:translate:button", true);
            // hide example translation
            Messenger.vent.trigger("hide:example:translation");
          }
        },
        this,
      );

      languages.onSynced(function () {
        languages.forEach((language) => {
          language.isEnglish = Messenger.reqres.request("kb:language:is:english", language);
          this.exampleModel.englishLanguages = languages.filter((lang) => lang.isEnglish);
        });
        this.showRegion(this.view);
      }, this);
    },
    getSelectedLocale: function () {
      return this.view.getLocaleId();
    },
    _setUpVents: function () {
      // This is called when adding/updating examples through quick-create. Since it doesn't have a parent module that
      // passes the selected locale (as it is done in topicExamplesModule), this trigger will set it instead
      Messenger.vent.on(
        "set:topic:example:locale",
        function (locale) {
          this.selectedLocale = locale;
        },
        this,
      );
    },
    _setUpReqres: function () {
      Messenger.reqres.setHandler(
        "topic:example:modal:locale",
        function () {
          return this.view.getLocaleId();
        },
        this,
      );
    },
  });
});
